import { Checkbox } from '@mantine/core';
import { TierLevel } from '@zorro/clients';
import { getTierLevelLabel } from '@zorro/common-utils';
import { Flex, Grid, Text } from '@zorro/web/design-system';

import classNames from './PlanFilter.module.scss';

const ORDERED_FILTER_VALUES = [
  TierLevel.bronze,
  TierLevel.expanded_bronze,
  TierLevel.silver,
  TierLevel.gold,
  TierLevel.platinum,
  TierLevel.catastrophic,
];

export const MetalFilters = ({
  filterOptions,
  selectedFilters,
}: {
  filterOptions: Set<TierLevel> | undefined;
  selectedFilters: string[];
}) => {
  if (!filterOptions) {
    return null;
  }
  return (
    <Grid columns={2} gap="sm">
      {ORDERED_FILTER_VALUES.map((filter) => {
        if (filterOptions.has(filter)) {
          const checkboxValue = filter;
          return (
            <Grid.Col key={filter} span={1}>
              <Checkbox.Card
                checked={selectedFilters?.includes(checkboxValue)}
                value={checkboxValue}
                className={classNames.checkboxCard}
              >
                <Flex p="md" align="center" gap="xs" h="3rem">
                  <div
                    className={classNames.filterIcon}
                    data-variant={filter}
                  />
                  <Text>{getTierLevelLabel(checkboxValue)}</Text>
                </Flex>
              </Checkbox.Card>
            </Grid.Col>
          );
        }
        return null;
      })}
    </Grid>
  );
};
